import $ from "jquery";
import Cookies from "js-cookie";

const COOKIE_TOKEN = "LEGACY-TOKEN";
const HEADER_TOKEN = "X-LEGACY-TOKEN";

function getAntiforgeryToken() {
    return Cookies.get(COOKIE_TOKEN);
}

const safeVerbs = ["GET", "HEAD", "OPTIONS"];
function isSafeVerb(verb: string): boolean {
    return safeVerbs.includes(verb?.toUpperCase());
}

export function setupAntiCSRFJQuery() {
    $(document as any).ajaxSend((_e, xhr, settings) => {
        if (!isSafeVerb(settings?.type)) {
            xhr.setRequestHeader(HEADER_TOKEN, getAntiforgeryToken());
        }
    });
}
